// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.KeyIndicatorsBlock_root__qjQBh {
  padding: 40px 0;
}
.KeyIndicatorsBlock_root__qjQBh .KeyIndicatorsBlock_wrapper__Agb-\\+ {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: calc(100vh - 135px);
  padding: 40px 0;
}
.KeyIndicatorsBlock_root__qjQBh .KeyIndicatorsBlock_wrapper__Agb-\\+ .KeyIndicatorsBlock_titleBlock__TD9a8 {
  margin-bottom: 40px;
  text-align: center;
  font-size: 26px;
  font-weight: bold;
  color: #00377c;
}
.KeyIndicatorsBlock_root__qjQBh .KeyIndicatorsBlock_wrapper__Agb-\\+ .KeyIndicatorsBlock_gridBlock__Ic0XD {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(2, 1fr);
  grid-column-gap: 250px;
  grid-row-gap: 40px;
}

@media (max-width: 991px) {
  .KeyIndicatorsBlock_root__qjQBh .KeyIndicatorsBlock_wrapper__Agb-\\+ {
    padding: 40px 0 0 0;
  }
  .KeyIndicatorsBlock_root__qjQBh .KeyIndicatorsBlock_wrapper__Agb-\\+ .KeyIndicatorsBlock_gridBlock__Ic0XD {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(1, 1fr);
    grid-column-gap: 140px;
    grid-row-gap: 20px;
  }
}
@media (max-width: 768px) {
  .KeyIndicatorsBlock_root__qjQBh {
    padding: 20px 0;
  }
  .KeyIndicatorsBlock_root__qjQBh .KeyIndicatorsBlock_wrapper__Agb-\\+ {
    padding: 20px 0 0 0;
    min-height: calc(100vh - 135px);
  }
  .KeyIndicatorsBlock_root__qjQBh .KeyIndicatorsBlock_wrapper__Agb-\\+ .KeyIndicatorsBlock_titleBlock__TD9a8 {
    margin-bottom: 20px;
    font-size: 18px;
  }
  .KeyIndicatorsBlock_root__qjQBh .KeyIndicatorsBlock_wrapper__Agb-\\+ .KeyIndicatorsBlock_gridBlock__Ic0XD {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(1, 1fr);
    grid-column-gap: 90px;
    grid-row-gap: 20px;
  }
}
@media (max-width: 768px) {
  .KeyIndicatorsBlock_root__qjQBh .KeyIndicatorsBlock_wrapper__Agb-\\+ {
    min-height: calc(100vh - 85px);
  }
  .KeyIndicatorsBlock_root__qjQBh .KeyIndicatorsBlock_wrapper__Agb-\\+ .KeyIndicatorsBlock_titleBlock__TD9a8 {
    font-size: 16px;
  }
  .KeyIndicatorsBlock_root__qjQBh .KeyIndicatorsBlock_wrapper__Agb-\\+ .KeyIndicatorsBlock_gridBlock__Ic0XD {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(1, 1fr);
    grid-column-gap: 90px;
    grid-row-gap: 10px;
  }
}
@media (max-width: 768px) {
  .KeyIndicatorsBlock_root__qjQBh .KeyIndicatorsBlock_wrapper__Agb-\\+ {
    min-height: calc(100vh - 81px);
  }
  .KeyIndicatorsBlock_root__qjQBh .KeyIndicatorsBlock_wrapper__Agb-\\+ .KeyIndicatorsBlock_titleBlock__TD9a8 {
    font-size: 16px;
  }
  .KeyIndicatorsBlock_root__qjQBh .KeyIndicatorsBlock_wrapper__Agb-\\+ .KeyIndicatorsBlock_gridBlock__Ic0XD {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(1, 1fr);
    grid-column-gap: 40px;
    grid-row-gap: 10px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Header/AboutUsMenu/KeyIndicatorsBlock/KeyIndicatorsBlock.module.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;AACF;AACE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,+BAAA;EACA,eAAA;AACJ;AACI;EACE,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AACN;AAEI;EACE,aAAA;EACA,qCAAA;EACA,kCAAA;EACA,sBAAA;EACA,kBAAA;AAAN;;AAKA;EAEI;IACE,mBAAA;EAHJ;EAKI;IACE,aAAA;IACA,qCAAA;IACA,kCAAA;IACA,sBAAA;IACA,kBAAA;EAHN;AACF;AAQA;EACE;IACE,eAAA;EANF;EAQE;IACE,mBAAA;IACA,+BAAA;EANJ;EAQI;IACE,mBAAA;IACA,eAAA;EANN;EASI;IACE,aAAA;IACA,qCAAA;IACA,kCAAA;IACA,qBAAA;IACA,kBAAA;EAPN;AACF;AAYA;EAEI;IACE,8BAAA;EAXJ;EAaI;IACE,eAAA;EAXN;EAcI;IACE,aAAA;IACA,qCAAA;IACA,kCAAA;IACA,qBAAA;IACA,kBAAA;EAZN;AACF;AAiBA;EAEI;IACE,8BAAA;EAhBJ;EAkBI;IACE,eAAA;EAhBN;EAmBI;IACE,aAAA;IACA,qCAAA;IACA,kCAAA;IACA,qBAAA;IACA,kBAAA;EAjBN;AACF","sourcesContent":[".root {\n  padding: 40px 0;\n\n  .wrapper {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    min-height: calc(100vh - 135px);\n    padding: 40px 0;\n\n    .titleBlock {\n      margin-bottom: 40px;\n      text-align: center;\n      font-size: 26px;\n      font-weight: bold;\n      color: #00377c;\n    }\n\n    .gridBlock {\n      display: grid;\n      grid-template-columns: repeat(3, 1fr);\n      grid-template-rows: repeat(2, 1fr);\n      grid-column-gap: 250px;\n      grid-row-gap: 40px;\n    }\n  }\n}\n\n@media (max-width: 991px) {\n  .root {\n    .wrapper {\n      padding: 40px 0 0 0;\n\n      .gridBlock {\n        display: grid;\n        grid-template-columns: repeat(2, 1fr);\n        grid-template-rows: repeat(1, 1fr);\n        grid-column-gap: 140px;\n        grid-row-gap: 20px;\n      }\n    }\n  }\n}\n\n@media (max-width: 768px) {\n  .root {\n    padding: 20px 0;\n\n    .wrapper {\n      padding: 20px 0 0 0;\n      min-height: calc(100vh - 135px);\n\n      .titleBlock {\n        margin-bottom: 20px;\n        font-size: 18px;\n      }\n\n      .gridBlock {\n        display: grid;\n        grid-template-columns: repeat(2, 1fr);\n        grid-template-rows: repeat(1, 1fr);\n        grid-column-gap: 90px;\n        grid-row-gap: 20px;\n      }\n    }\n  }\n}\n\n@media (max-width: 768px) {\n  .root {\n    .wrapper {\n      min-height: calc(100vh - 85px);\n\n      .titleBlock {\n        font-size: 16px;\n      }\n\n      .gridBlock {\n        display: grid;\n        grid-template-columns: repeat(2, 1fr);\n        grid-template-rows: repeat(1, 1fr);\n        grid-column-gap: 90px;\n        grid-row-gap: 10px;\n      }\n    }\n  }\n}\n\n@media (max-width: 768px) {\n  .root {\n    .wrapper {\n      min-height: calc(100vh - 81px);\n\n      .titleBlock {\n        font-size: 16px;\n      }\n\n      .gridBlock {\n        display: grid;\n        grid-template-columns: repeat(2, 1fr);\n        grid-template-rows: repeat(1, 1fr);\n        grid-column-gap: 40px;\n        grid-row-gap: 10px;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `KeyIndicatorsBlock_root__qjQBh`,
	"wrapper": `KeyIndicatorsBlock_wrapper__Agb-+`,
	"titleBlock": `KeyIndicatorsBlock_titleBlock__TD9a8`,
	"gridBlock": `KeyIndicatorsBlock_gridBlock__Ic0XD`
};
export default ___CSS_LOADER_EXPORT___;
